import { render } from "./DashboardTabsOld.vue?vue&type=template&id=3fec1011"
import script from "./DashboardTabsOld.vue?vue&type=script&lang=js"
export * from "./DashboardTabsOld.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__